<template>
  <div>
    <b-alert v-if="candidates.error">
      Error loading candidates...
    </b-alert>
    <div v-else-if="candidates.data">
      <!--<b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="justify-content-center"
      />-->
      <b-table
        :items="filteredCandidates"
        :fields="fields"
        :current-page="currentPage"
        per-page="0"
        :busy="candidates.loading"
        show-empty
        v-bind="tableProps"
      >
        <template v-if="!isListView" v-slot:cell(first_name)="data">
          {{ data.item.first_name }} {{ data.item.last_name }}
        </template>
        <template v-if="!isListView" v-slot:cell(email_address)="data">
          <b-link
            v-if="data.item.email_address"
            :href="`mailto:${data.item.email_address}`"
            target="_top"
            class="btn btn-primary"
          >
            <span class="fas fa-at"></span> Email
          </b-link>
          <span v-else>-</span>
        </template>
        <template v-if="!isListView" v-slot:cell(tags_name)="data">
          <span v-if="data.item.tags_name">{{ data.item.tags_name }}</span>
          <span v-else>-</span>
        </template>
        <template
          v-if="!isListView"
          v-slot:cell(availability_description)="data"
        >
          <span v-if="data.item.availability_description">{{
            data.item.availability_description
          }}</span>
          <span v-else>-</span>
        </template>
        <template
          v-if="!isListView"
          v-slot:cell(minimum_day_rate_description)="data"
        >
          <span v-if="data.item.minimum_day_rate_description">{{
            data.item.minimum_day_rate_description
          }}</span>
          <span v-else>-</span>
        </template>
        <template v-if="!isListView" v-slot:cell(locations_name)="data">
          <span v-if="data.item.locations_name"
            >{{ data.item.locations_name }}
            <div v-if="data.item.regions_name">
              {{ data.item.regions_name }}
            </div>
          </span>
          <span v-else>-</span>
        </template>
        <template v-if="!isListView" v-slot:cell(regions_name)="data">
          <span v-if="data.item.regions_name">{{
            data.item.regions_name
          }}</span>
          <span v-else>-</span>
        </template>
        <template v-if="!isListView" v-slot:cell(referrals)="data">
          <ReferencesModal :candidate="data.item" link />
        </template>
        <template v-if="!isListView" v-slot:cell(additional_information)="data">
          <AdditionalInformationModal :candidate="data.item" link />
        </template>
        <template v-else v-slot:cell(candidate)="data">
          <CandidateInfo :candidate="data.item" />
        </template>
        <template v-slot:table-busy>
          <content-placeholders v-if="candidates.loading">
            <content-placeholders-text :lines="10" />
          </content-placeholders>
        </template>
      </b-table>
      <!--<b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="justify-content-center"
      />-->
    </div>
  </div>
</template>

<script>
import { pipe, filter, get, some } from 'lodash/fp'
import CandidateInfo from './CandidateInfo/CandidateInfo'
import ReferencesModal from './ReferencesModal/ReferencesModal'
import AdditionalInformationModal from './AdditionalInformationModal/AdditionalInformationModal'
import {
  CARD_MODE_FIELDS,
  LIST_MODE_FIELDS
} from '../../../constants/candidatesList'
export default {
  name: 'CandidatesList',
  components: {
    CandidateInfo,
    ReferencesModal,
    AdditionalInformationModal
  },
  props: {
    candidates: {
      type: Object,
      required: true
    },
    isListView: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      search: '',
      filters: [
        'first_name',
        'last_name',
        'email_address',
        'tags_name',
        'availability_description',
        'minimum_day_rate_description',
        'locations_name',
        'regions_name',
        'referrals',
        'website',
        'additional_information'
      ],
      totalRows: this.candidates.data.length,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    filteredCandidates() {
      return this.filterData(this.candidates.data)
    },
    fields() {
      return this.isListView ? CARD_MODE_FIELDS : LIST_MODE_FIELDS
    },
    tableProps() {
      return this.isListView
        ? {
            borderless: true,
            'td-class': 'borderless',
            'thead-class': 'd-none'
          }
        : {
            responsive: true,
            stickyColumn: true,
            hover: true,
            striped: true,
            borderless: true
          }
    }
  },
  watch: {
    search() {
      this.currentPage = 1
      this.totalRows = this.filteredCandidates.length
      this.$emit('filtered', this.filteredCandidates)
    },
    'candidates.data'(value) {
      this.search = ''
      this.totalRows = value.length
      this.$emit('filtered', value)
    }
  },
  methods: {
    filterData(data) {
      return pipe(
        filter(it =>
          some(key => {
            return String(get(key, it))
              .toLowerCase()
              .includes(this.search.toLowerCase())
          }, this.filters)
        )
      )(data)
    }
  }
}
</script>
<style lang="scss">
.CandidateList__width_email {
  width: 114px;
}
</style>
